import React from 'react'
import { Popover } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tracker } from "../../../../../util/analytics";
import { getUser } from "../../../../../util/helpers";
import { selectedQueueView } from "../../../state/actions/queueMonitorActions";
import { QueueDetailedViewSearch } from "./QueueDetailedViewSearch";

const QueueViewSelectionPopper = (props) => {
  const [queueOptions, setQueueOptions] = useState([]);
  const [allQueuesList, setAllQueuesList] = useState([]);
  const dispatch = useDispatch();

  const { open, anchorEl, handleClose } = { ...props };

  const queueDetails = useSelector(
    (state) => state.queueMonitor.allQueuesDetails
  );

  const selectedQueueCallHandling = useSelector(
    (state) => state.queueMonitor.selectedQueueDetails
  );
  const selectedTab = useSelector(
    (state) => state.liveInteractionsSlice.activeTab
  );

  useEffect(() => {
    if (
      queueDetails &&
      queueDetails.length &&
      Object.keys(selectedQueueCallHandling).length
    ) {
      const queueOptionsList = [];
      queueDetails.forEach((item) => {
        queueOptionsList.push({
          label: item["queue"]["queue_name"],
          value: item["queue"]["queue_id"],
          selected:
            item["queue"]["queue_id"] === selectedQueueCallHandling["queue_id"]
              ? true
              : false,
        });
      });
      setQueueOptions(queueOptionsList);
      setAllQueuesList(queueOptionsList);
    }
  }, [queueDetails, selectedQueueCallHandling, selectedTab, open]);

  const handleSelectedQueueOption = (item, index) => {
    queueOptions.map((queue) => {
      queue["selected"] = false;
    });
    item["selected"] = true;
    let findQueueObj = queueDetails.find((obj) => obj.queue_id === item.value);
    Tracker.event(
      "Queue Monitoring Detail",
      "Click",
      "Queue Name Drop Down",
      "Queue Name Drop Down Click",
      getUser()
    );
    dispatch({ type: "ClearMainFilters", payload: {} });
    dispatch(selectedQueueView(findQueueObj));
    handleClose();
  };

  const handleSearchInput = (value) => {
    const searchFiltered = allQueuesList.filter((queue) => {
      return (
        queue["label"] &&
        queue["label"].toLowerCase().indexOf(value.toLowerCase()) > -1
      );
    });
    setQueueOptions(searchFiltered);
  };

  return (
    <Popover
      className="mt-7"
      id={open ? "queue-view-popover" : undefined}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        style: {
          backgroundColor: "white",
          borderRadius: 0,
          maxHeight: "70%",
          minWidth: "150px",
          maxWidth: "300px",
          padding: "30px",
        },
      }}
    >
      <div className="mb-5">
        <span>
          <strong> Queue</strong>
        </span>
      </div>
      <div className="my-3">
        <QueueDetailedViewSearch handleSearch={handleSearchInput} />
      </div>
      {queueOptions.map((option, index) => {
        return (
          <div
            className={`py-4  ${option.selected && "queue-view-item"}`}
            style={{ cursor: "pointer" }}
            onClick={() => handleSelectedQueueOption(option, index)}
            key={index}
          >
            <span
              className="m-5"
              style={option.selected ? { color: "#3419b6" } : {}}
            >
              {option.label.length > 25
                ? option.label.substring(0, 25) + "..."
                : option.label}
            </span>
          </div>
        );
      })}
      {queueOptions.length === 0 && (
        <div className="text-center">No Result Found</div>
      )}
    </Popover>
  );
};

export default QueueViewSelectionPopper;
